export const ContentWidth = {
  Fluid: "fluid",
  Boxed: "boxed",
} ;

export const NavbarType = {
  Sticky: "sticky",
  Static: "static",
  Hidden: "hidden",
} ;

export const FooterType = {
  Sticky: "sticky",
  Static: "static",
  Hidden: "hidden",
} ;

export const AppContentLayoutNav = {
  Vertical: "vertical",
  Horizontal: "horizontal",
} ;

export const HorizontalNavType = {
  Sticky: "sticky",
  Static: "static",
  Hidden: "hidden",
} ;
